import { Link, Text } from "basis";

export const PersonalLoanContent = () => (
  <Text testId="personal-loan-content">
    We’re unable to provide your payment notification preferences via the
    Latitude website. Please contact Latitude{" "}
    <Link href="/contact" newTab={false}>
      customer support
    </Link>
    .
  </Text>
);
